import { useRouter } from 'next/dist/client/router';
import React, { useEffect } from 'react';
import Cards from '../../components/Cards/Cards';

const CardsPageLayout = () => {
  return <Cards />;
};

export default CardsPageLayout;
